export const AvailabilityInStoresProj = `#graphql
fragment AvailabilityInStoresProj on AvailabilityInStores{
  qty
  source_name
  source_code
  status
}
`
